import { render, staticRenderFns } from "./Calculations.vue?vue&type=template&id=609c3dd0&"
import script from "./Calculations.vue?vue&type=script&lang=js&"
export * from "./Calculations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports